import { createContext, useState } from 'react';
import api from 'services/api';

export const MarcaContext = createContext();

export const MarcaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [marca, setMarca] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getMarca = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: marca?.filter,
        page: marca?.page,
        size: marca?.size,
        order: marca?.order,
        ...payload,
      });
      setMarca((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <MarcaContext.Provider
      value={{
        getLoading,
        marca,
        getMarca,
      }}
    >
      {children}
    </MarcaContext.Provider>
  );
};
